module.exports = "<div class=\"content-top clearfix\">\n  <!-- <h1 class=\"al-title\">{{ activePageTitle }}</h1> -->\n\n  <!-- <ul class=\"breadcrumb al-breadcrumb\">\n    <li class=\"breadcrumb-item\"><a routerLink=\"/pages/dashboard\">Home</a></li>\n    <li class=\"breadcrumb-item active\">{{ activePageTitle }}</li>\n  </ul> -->\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /var/www/_deploy/front-company-testing/2018-09-30-21-57-10/src/app/theme/components/baContentTop/baContentTop.html
// module id = ../../../../../src/app/theme/components/baContentTop/baContentTop.html
// module chunks = main